import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";

export default function Globale() {
    return (
        <div className="space-y-6">
            <h2 className="text-3xl font-bold tracking-tight">
                Global-e Integration
            </h2>
            <div className="grid gap-6">
                <Card>
                    <CardHeader>
                        <CardTitle>Overview</CardTitle>
                        <CardDescription>
                            Connecting Optifi to Global-e
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            Global-e provides international shipping and customs
                            solutions for e-commerce businesses. This
                            integration allows Optifi to work seamlessly with
                            Global-e's services for international markets.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">Integration benefits:</p>
                            <ul className="mt-2 list-disc pl-4 text-sm space-y-2">
                                <li>Seamless international shipping setup</li>
                                <li>Automated customs documentation</li>
                                <li>International market expansion support</li>
                                <li>Streamlined cross-border operations</li>
                            </ul>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>Setup Process</CardTitle>
                        <CardDescription>
                            Getting started with Global-e
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            The main piece of information you need to provide
                            Optifi is your Global-e merchant GUID. This is a
                            unique identifier for your Global-e account that
                            will have been provided by Global-e when you signed
                            up for their services. If you don't have this, you
                            should be able to request it from Global-e support.
                        </p>
                        <p className="text-sm text-muted-foreground">
                            Once you have your merchant GUID, you can enter it
                            into the Globale integration settings in Optifi in
                            the Integrations page.
                        </p>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>Integration Features</CardTitle>
                        <CardDescription>
                            Working with Global-e in Optifi
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            Once connected, Optifi will make sure that prices
                            are updated via Global-e, rather than through
                            Shopify Markets. This means it will be fully
                            compatible with your current workflow without any
                            additional changes.
                        </p>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
